// import axios from 'axios';
// import HoldOn from 'react-hold-on';
// import apiUrl from '../../ApiUrl';

// export const ocrUploadFileAPI = async (file,type, id) => {
//     const options = {
//         theme: 'sk-folding-cube',
//         message: 'Uploading File...',
//         textColor: 'pink',
//     };

//     if (!file || !file.name) {
//         console.error("No valid file provided for upload.");
//         return;
//     }

//     try {
//         HoldOn.open(options);

//         const formData = new FormData();
//         formData.append('file', file);  
//         formData.append('file_key', type);  
//         formData.append('uid', id);

//         console.log("OCR Form Data",formData);       

//         for (let pair of formData.entries()) {
//             console.log(`${pair[0]}: ${pair[1]}`);
//         }

//         const response = await axios.post(`${apiUrl}doc-extract`, formData, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//         });

//         console.log("Response:", response.data);

//         if (response.data) {
//             console.log(response.data);
//         } else {
//             throw new Error("Unexpected response from the server");
//         }
//     } catch (error) {
//         console.error("Error uploading file:", error);
//         // dispatch(docError("Error uploading file"));
//     } finally {
//         HoldOn.close();
//     }
// };

// actions.js
import axios from 'axios';
import apiUrl from '../../ApiUrl';
import HoldOn from 'react-hold-on';
import { getOcrDataSuccess, ocrIdDataStart, ocrUploadFileIdStart } from '../../Reducer/ocrReducer';
import { useSelector } from 'react-redux';

export const ocrUploadFileAPI = (file, type, id) => {
    return async (dispatch) => {
        if (!file || !file.name) {
            console.error("No valid file provided for upload.");
            return;
        }

        try {
            console.log("files", file);
            console.log("type", type);
            console.log("id", id);
            const formData = new FormData();
            formData.append("files", file);
            formData.append("file_key", type);
            formData.append("uid", id);

            const response = await axios.post(`${apiUrl}file/ocr_submit`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log("Response:", response.data);
            // dispatch(ocrUploadFileIdStart(response.data.ID));
            const ocrIdData=useSelector((state)=>state.ocr?.ocrUploadFileId);
            console.log("OCR ID Data", ocrIdData);

        } catch (error) {
            console.error("Error uploading file:", error);
        }
    };
};


export const getOcrStatusByID=(id)=>{
    return async(dispatch)=>{
        try{
            const response=await axios.post(`${apiUrl}getDetails?uid=${id}`,{
                headers:{
                    'Content-Type':'multipart/form-data',
                },
            });
            // dispatch(ocrIdDataStart(response.data));
            console.log("Response:", response.data);
        }
        catch(error){
            console.error("Error uploading file:", error);
        }
    }
}

//for temporary
// export const getOcrDataAPI = (id) => async (dispatch, getState) => {
//     const options = {
//         theme: 'sk-cube-grid',
//         message: 'fetching details...',
//     };
//     try {
//         HoldOn.open(options);
//         const response = await axios.get(`${apiUrl}mock-api/doc-extract/details/uid?uid=${id}`);
//         if(response.data){
//             dispatch(getOcrDataSuccess(response.data));
//             const ocrData = getState().ocr?.ocrData;
//             console.log("ocr",ocrData);
//         }
//         console.log("Response:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching OCR data:", error);
//         return null;
//     } finally {
//         HoldOn.close();
//     }
// };

// export const getOcrDataAPI = (id) => async (dispatch, getState) => {
//     const options = {
//         theme: 'sk-cube-grid',
//         message: 'fetching details...',
//     };
//     try {
//         HoldOn.open(options);

//         const headers = {
//             'uid': id
//         };

//         const response = await axios({
//             method: 'GET',
//             url: `${apiUrl}file/details`,
//             headers: headers,
//         });

//         if(response.data){
//             dispatch(getOcrDataSuccess(response.data));
//             const ocrData = getState().ocr?.ocrData;
//             console.log("ocr",ocrData);
//         }
//         console.log("Response:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching OCR data:", error);
//         return null;
//     } finally {
//         HoldOn.close();
//     }
// };

// added timer for 20 sec 
export const getOcrDataAPI = (id) => async (dispatch, getState) => {
    const options = {
        theme: 'sk-cube-grid',
        message: 'fetching details...',
    };

    try {
        // Show loader
        HoldOn.open(options);

        // Delay the API call by 20 seconds
        await new Promise((resolve) => setTimeout(resolve, 20000));

        const headers = {
            'uid': id
        };

        const response = await axios({
            method: 'GET',
            url: `${apiUrl}file/details`,
            headers: headers,
        });

        if (response.data) {
            dispatch(getOcrDataSuccess(response.data));
            const ocrData = getState().ocr?.ocrData;
            console.log("ocr", ocrData);
        }

        console.log("Response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching OCR data:", error);
        return null;
    } finally {
        // Close loader
        HoldOn.close();
    }
};
